import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Eyebrow } from './Eyebrow';
import { Reveal } from './Reveal';
import { AffiliateCTA } from './AffiliateCTA';
import type { PillarPageContent } from '../types/pillarPage';
type FormationSectionProps = {
  content: PillarPageContent['formation'];
  affiliateUrl: string;
};
export function FormationSection({
  content,
  affiliateUrl
}: FormationSectionProps) {
  return <section id="formacion" className="relative w-full overflow-hidden bg-ink py-28 lg:py-40" data-id="element-71" data-mp="100z5xiidvwc7">
      <div className="pointer-events-none absolute left-1/2 top-1/3 h-[600px] w-[900px] -translate-x-1/2 rounded-full bg-accent/[0.06] blur-[160px]" aria-hidden="true" data-id="element-72" data-mp="vzdk37nvg7pv" />

      <div className="relative mx-auto w-full max-w-[1240px] px-6 sm:px-10" data-id="element-73" data-mp="150twfky8yjwq">
        <Reveal data-id="element-74" data-mp="3brb52l4ddxbq">
          <div className="max-w-2xl" data-id="element-75" data-mp="3bqrop8udbgzt">
            <Eyebrow data-id="element-76" data-mp="3brtd0f0e9zzh">{content.eyebrow}</Eyebrow>
            <h2 className="mt-6 text-3xl font-extrabold leading-[1.1] tracking-[-0.025em] text-bone sm:text-4xl lg:text-[3rem]" data-id="element-77" data-mp="36szw0clwfquk">
              {content.title}
            </h2>
            <div className="mt-8 space-y-5 text-[15px] leading-relaxed text-ash sm:text-base" data-id="element-78" data-mp="1fwaj1gryulwe">
              {content.paragraphs.map(paragraph => <p key={paragraph} data-id="element-79" data-mp="1oy07cdqjx4py">{paragraph}</p>)}
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.08} data-id="element-80" data-mp="1tr35z0a6r4d0">
          <article className="mt-16 overflow-hidden rounded-3xl border border-accent/25 bg-surface shadow-[0_60px_120px_-70px_rgb(var(--accent)/0.55)]" data-id="element-81" data-mp="1yolfars47llj">
            <div className="grid grid-cols-1 gap-10 p-9 lg:grid-cols-12 lg:items-center lg:gap-16 lg:p-14" data-id="element-82" data-mp="23meh78mdxtg0">
              <div className="lg:col-span-7" data-id="element-83" data-mp="28nalhnanfhly">
                <Eyebrow data-id="element-84" data-mp="2co48meg9osds">{content.cardEyebrow}</Eyebrow>
                <h3 className="mt-6 text-2xl font-extrabold leading-[1.1] tracking-[-0.02em] text-bone sm:text-3xl lg:text-4xl" data-id="element-85" data-mp="2cnl3xzfmo0hp">
                  {content.cardTitle}
                </h3>
                <p className="mt-5 text-lg font-medium text-accent" data-id="element-86" data-mp="iav99fhfqn99">{content.cardQuote}</p>
                <ul className="mt-9 flex flex-wrap gap-x-8 gap-y-3" data-id="element-87" data-mp="1lm2008ao3dwg">
                  {content.highlights.map(item => <li key={item} className="flex items-center gap-2.5 text-[11px] font-semibold uppercase tracking-label text-ash" data-id="element-88" data-mp="1go0l7zk9y0qs">
                      <CheckIcon className="h-3.5 w-3.5 text-accent" strokeWidth={2} aria-hidden="true" data-id="element-89" data-mp="1qmgary3nl1y6" />
                      {item}
                    </li>)}
                </ul>
              </div>

              <div className="lg:col-span-5 lg:border-l lg:border-accent-deep/70 lg:pl-14" data-id="element-90" data-mp="2ebr1snv7bhz4">
                <AffiliateCTA label={content.ctaLabel} href={affiliateUrl} className="w-full" data-id="element-91" data-mp="29cxxnm1t13bm" />
                <p className="mt-5 text-[13px] leading-relaxed text-ash/70" data-id="element-92" data-mp="2n8jn1uby9p4k">{content.note}</p>
              </div>
            </div>
          </article>
        </Reveal>
      </div>
    </section>;
}